import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  > div:nth-of-type(2) {
    max-width: 800px;
    margin-top: 60px;
    margin-bottom: 60px;

    > form {
      > div {
        width: 100%;
      }

      > button {
        outline: 0;
        height: 5rem;
        border-radius: 40px;
        margin: 40px auto;
      }
    }

    h1 {
      font-family: 'Montserrat', sans-serif;
      font-weight: 700;
      font-size: 4rem;
      color: var(--green24);
      margin: 40px 0px 40px 0px;
    }

    span {
      display: block;
      font-family: 'Montserrat', sans-serif;
      font-size: 1.5rem;
      font-weight: 600;
      color: #131e23;
      margin: 40px 0px 20px 0px;
      cursor: pointer;
    }

    .input {
      color: #a2a2a2;

      ::placeholder {
        color: #a2a2a2;
      }
    }

    label {
      font-family: 'Montserrat', sans-serif;
      font-size: 1.5rem;
      font-weight: 600;
      color: #131e23;
      margin-left: 6px;
    }

    input[type='checkbox'] {
      height: 100px;
    }

    > img {
      display: block;
      margin: 40px auto -40px auto;
      cursor: pointer;
    }
  }
`;

export const GradientBackground = styled.div`
  position: absolute;
  top: 0px;
  width: 100%;
  height: 500px;
  z-index: -1;
  background: #e84e22;
  background: linear-gradient(
    180deg,
    #e84e22 0%,
    rgba(248, 251, 246, 1) 70%,
    rgba(255, 255, 255, 1) 80%
  );
`;

export const SelectedPlanBadge = styled.div`
  font-family: 'Montserrat', sans-serif;
  font-size: 1rem;
  font-weight: 600;
  color: #131e23;

  width: fit-content;
  max-width: 90%;

  margin: 1rem auto 0 auto;
  padding: 0.6rem 1.2rem;

  background-color: #f9ede4;
  border: 1px solid #e84e22;
  border-radius: 40px;

  text-align: center;

  strong {
    color: #e84e22;
  }
`;

export const FreeTrialMessage = styled.div`
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 1.3rem;
  color: white;
  padding: 20px 10px;
  width: 25rem;
  background-color: #e84e22;
  border-radius: 40px;
  text-align: center;
  margin: 0 auto;
`;

export const Row = styled.div`
  display: flex;
`;

export const Tooltip = styled.div`
  font-family: 'Montserrat', sans-serif;
  font-size: 1.2rem;
  margin-top: 20px;
  color: #e84e22;
  text-align: center;
`;
